<template>
  <ViewCustomData entityName="form_script" entitySpec="data" serviceName="BaseService" :columns="columns"
    :dictionary="dictionary" :masterDetail="{ script_id: scriptId }" ref="viewFormScript" :paginator="false"
    scrollHeight="300px" mode="edit" :requiredFieldsTable="{
      form_id: true,
      facility_type_id: true,
    }" :prepareUpdate="prepareUpdate" :prepareInsert="prepareInsert">
    <template #header>Связанные объекты</template>
  </ViewCustomData>
</template>

<script setup>
import { ref, computed, defineProps } from 'vue';
import { useStore } from 'vuex';

//defineOptions({ name: 'FormScript' });

const props = defineProps({
  scriptId: {
    type: [String, Number],
    required: true,
  },
});

const store = useStore();

const formScriptService = ref(null);
const selectedFormScript = ref(null);
const newFormScript = ref(false);
const formScript = ref(null);
const isDelete = ref(false);
const isLoading = ref({ formScript: false });
const isChange = ref(false);

const viewFormScript = ref(null);

const dictionary = [
  {
    options: 'form',
    save: { store: false, self: true },
    load: 'db',
    serviceName: 'BaseService',
    entityName: 'form',
    params: { is_main: true },
  },
  {
    options: 'facilityType',
    save: { store: false, self: true },
    load: 'db',
    serviceName: 'BaseService',
    entityName: 'facility_type',
  },
];

const columns = computed(() => [
  {
    header: 'Форма',
    field: 'form_id',
    loadOptions: 'form',
    dataType: 'dropdown',
    editor: {
      name: 'Dropdown',
      attrList: {
        options: [],
        optionLabel: 'form_name',
        optionValue: 'form_id',
        appendTo: 'body',
        filtre: true,
      },
    },
  },
  {
    header: 'Тип объекта',
    field: 'facility_type_id',
    loadOptions: 'facilityType',
    dataType: 'dropdown',
    editor: {
      name: 'Dropdown',
      attrList: {
        options: [],
        optionLabel: 'facility_type_name',
        optionValue: 'facility_type_id',
        appendTo: 'body',
        filtre: true,
      },
    },
  },
  {
    header: 'Объект',
    field: 'facility_id',
    dataType: 'dropdown',
    editor: {
      name: 'Dropdown',
      attrList: {
        options: store.getters.facility, // 
        optionLabel: 'facility_name',
        optionValue: 'facility_id',
        appendTo: 'body',
        filter: true,
        showClear: true,
      },
    },
  },
]);

// Методы
const prepareUpdate = (data) => {
  const dataNew = { ...data };
  delete dataNew.facility_name;
  delete dataNew.facility_type_name;
  delete dataNew.form_name;
  return dataNew;
};

const prepareInsert = (data) => {
  const dataNew = { ...data };
  delete dataNew.form_script_id;
  dataNew.script_id = props.scriptId;
  return dataNew;
};
</script>